import { StatusBar } from "expo-status-bar";
import { StyleSheet, View } from "react-native";
import { GestureHandlerRootView } from "react-native-gesture-handler";

import { fonts, navigationTheme } from "./config";
import { ErrorBoundary, useAuthStore } from "./services";
import { useAppLoading } from "./services/epox/services";
import { Navigation, ErrorScreen } from "./screens";
import "./events";

export function App() {
  // Store
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const isAuthenticated = useAuthStore((s) => s.token !== null);

  // Vars
  const { isLoading: isAppLoading, hideSplashScreen } = useAppLoading(fonts);

  // Render
  if (isAppLoading || isHydrating) {
    return null;
  }

  return (
    <View
      key={isAuthenticated ? "authenticated" : "guest"}
      onLayout={hideSplashScreen}
      style={$.container}
    >
      <GestureHandlerRootView>
        <ErrorBoundary FallbackComponent={ErrorScreen}>
          <StatusBar style="dark" />
          <Navigation theme={navigationTheme} />
        </ErrorBoundary>
      </GestureHandlerRootView>
    </View>
  );
}

const $ = StyleSheet.create({
  container: {
    flex: 1,
  },
});
